import { useEffect } from "react";
import { LayoutDashboard, FolderOpen, ListTodo } from "lucide-react";
import { AppShell } from "../../layouts/AppShell";
import { getCurrentOrgType } from "../../../state/orgContext";

type OpsLandingPageProps = {
  userName?: string;
  onBackToDashboard?: () => void;
  onOpenDashboard?: () => void;
  onOpenDossiers?: () => void;
  onOpenMyWork?: () => void;
};

export function OpsLandingPage({
  userName = "Utilisateur",
  onBackToDashboard,
  onOpenDashboard,
  onOpenDossiers,
  onOpenMyWork,
}: OpsLandingPageProps) {
  const orgType = getCurrentOrgType();

  useEffect(() => {
    if (orgType === "partner_org" && onOpenMyWork) {
      onOpenMyWork();
    }
  }, [orgType, onOpenMyWork]);

  const cards = [
    {
      title: "Cockpit",
      subtitle: "Vue directeur : risques SLA, blocages, charge",
      icon: LayoutDashboard,
      onClick: onOpenDashboard,
    },
    {
      title: "Dossiers",
      subtitle: "Liste des engagements et process cases",
      icon: FolderOpen,
      onClick: onOpenDossiers,
    },
    {
      title: "Mes activités",
      subtitle: "Tâches qui me sont assignées",
      icon: ListTodo,
      onClick: onOpenMyWork,
    },
  ].filter((c) => (orgType === "partner_org" ? c.title === "Mes activités" : true));

  return (
    <AppShell
      userName={userName}
      topbar={
        <div className="flex items-center gap-4">
          {onBackToDashboard && (
            <button
              type="button"
              onClick={onBackToDashboard}
              className="text-sm text-muted hover:text-text"
            >
              Tableau de bord
            </button>
          )}
          <span className="text-sm font-medium text-text">Opérations</span>
        </div>
      }
    >
      <div className="ds-container py-8">
        <h1 className="text-xl font-semibold text-text mb-2">Opérations</h1>
        <p className="text-sm text-muted mb-6">
          Accédez au cockpit, aux dossiers ou à vos activités assignées.
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 max-w-4xl">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <button
                key={card.title}
                type="button"
                onClick={card.onClick}
                className="flex items-start gap-4 rounded-lg border border-border bg-surface p-5 text-left shadow-sm transition hover:border-primary/30 hover:shadow"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-medium text-text">{card.title}</div>
                  <div className="mt-1 text-sm text-muted">{card.subtitle}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </AppShell>
  );
}
